<template>
  <span class="diag-notavailable"></span>
</template>
<script>
export default {
  name: 'diag-notavailable'
}
</script>
<style lang="less">
.legend-icon.diag-notavailable {
  width: 0 !important;
}
</style>
